import React, { useState, useEffect } from "react";
import sliderCloseIcon from "../../assets/images/slider-close-icon.svg";
import { useDispatch } from "react-redux";
import { editContact } from "../../redux/action";
import AsyncCreatable from "react-select/creatable";
import { useSelector } from "react-redux";
import { encodePhoneNumber } from "../../helpers/Utils";
import { Alert } from "reactstrap";
import { Box, Image } from "@chakra-ui/react";
export default function EditContactSlider({
  selectedContact,
  handleEditContact,
  setSelectedContact,
}) {
  const dispatch = useDispatch();
  const [options, setOptions] = useState([]);
  const [validationErrors, setValidationErrors] = useState([]);
  const tags = useSelector((state) => state.tags);
  const [selectedTags, setSelectedTags] = useState([]);
  const getOptions = () => {
    let opts = [];
    tags.data.map((item) => {
      opts.push({ value: item.id, label: item.tag });
    });
    setOptions([...opts]);
  };

  const handleEdit = () => {
    let errors = [];
    if (selectedContact.first_name === "") {
      errors.push({ error: "First Name is Required!" });
    }
    if (selectedContact.last_name === "") {
      errors.push({ error: "Last Name is Required!" });
    }
    if (encodePhoneNumber(selectedContact.phone_no).length < 14) {
      errors.push({ error: "Valid Phone Number is Required!" });
    }
    setValidationErrors(errors);

    if (errors.length === 0) {
      let updatedContact = selectedContact;
      updatedContact.tags = selectedTags;

      let newPhone = ("1" + updatedContact.phone_no).replace(/[(+)]/g, "");

      dispatch(editContact({ ...updatedContact, phone_no: newPhone }));
    }
  };

  const getSelectedTags = () => {
    let selectedTagsArray = [];
    let modalContact = selectedContact;
    if ("tags" in modalContact) {
      modalContact.tags.forEach((element) => {
        selectedTagsArray.push({
          label: element.tag,
          value: element.id,
        });
      });
    }

    setSelectedTags(selectedTagsArray);
  };
  useEffect(() => {
    getSelectedTags();
  }, [selectedContact]);

  useEffect(() => {
    //getSelectedTags()
    getOptions();
  }, [tags]);
  const userSelectedFont = useSelector((state) => state.settings.fontsize);
  return (
    <div
      className="offcanvas offcanvas-end"
      tabIndex="-1"
      id="editContactCanvas"
      aria-labelledby="editContactCanvasLabel">
      <div className="offcanvas-header">
        <Box
          fontSize={
            userSelectedFont === "small"
              ? "18px"
              : userSelectedFont === "medium"
              ? "20px"
              : userSelectedFont === "large"
              ? "24px"
              : "24px"
          }
          className="offcanvas-title"
          id="editContactCanvasLabel">
          Edit Contact
        </Box>
        <button
          type="button"
          className="slider-close-btn"
          data-bs-dismiss="offcanvas">
          <Image
            boxSize={
              userSelectedFont === "small"
                ? "28px"
                : userSelectedFont === "medium"
                ? "30px"
                : userSelectedFont === "large"
                ? "38px"
                : "38px"
            }
            src={sliderCloseIcon}
          />
        </button>
      </div>
      <div className="offcanvas-body">
        {validationErrors.map((error) => (
          <Alert color="danger">{error.error}</Alert>
        ))}
        <div className="tags mb-3">
          <input
            type="text"
            className="form-control slider-inputs"
            onChange={handleEditContact}
            name="first_name"
            placeholder="First Name"
            value={selectedContact.first_name}
          />
        </div>
        <div className="tags mb-3">
          <input
            type="text"
            className="form-control slider-inputs"
            onChange={handleEditContact}
            name="last_name"
            placeholder="Last Name"
            value={selectedContact.last_name}
          />
        </div>
        <div className="tags mb-3">
          <input
            type="text"
            className="form-control slider-inputs"
            onChange={handleEditContact}
            name="phone_no"
            placeholder="Phone Number"
            value={encodePhoneNumber(selectedContact.phone_no)}
          />
        </div>
        <AsyncCreatable
          options={options}
          isMulti
          value={selectedTags}
          // defaultValue={selectedContact.tags}

          placeholder="Tags"
          onChange={(value) => setSelectedTags(value)}
        />
        <div className="d-flex justify-content-end mt-4">
          <button
            className="slider-cancel-btn me-2"
            data-bs-dismiss="offcanvas">
            Cancel
          </button>
          <button
            className="slider-success-btn"
            data-bs-dismiss="offcanvas"
            onClick={handleEdit}>
            Update
          </button>
        </div>
      </div>
    </div>
  );
}
